module.exports = __webpack_public_path__ + "static/media/share.54625e9c.svg";